import { Elm } from "../optimized.js";
import { init } from "./main";

init(Elm);
